<template>
  <div class="gift-box__change-used-btn">
    <!-- TODO: btn-multi コンポーネントが出来次第、コンポーネントを利用する形に変更する -->
    <button class="btn-multi btn-multi--single" @click="clickButton">
      <span class="btn-multi-checkmark">
        利用済みにする
      </span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    ticketId: {
      type: Number,
      required: true
    }
  },
  methods: {
    clickButton() {
      this.$emit('clickButton')
    }
  }
}
</script>
